<script setup lang="ts">
import AlertIcon from 'vue-material-design-icons/Alert.vue';
import OpenInNewIcon from 'vue-material-design-icons/OpenInNew.vue';
</script>

<template>
  <div class="bg-cream-200 pb-10">
    <div
      class="max-w-content-width mx-auto bg-white border-b border-cream-500 rounded px-5 py-6 text-gray-500 flex gap-5"
    >
      <AlertIcon class="text-brown-300" :size="30" />
      <div class="text-sm">
        <p class="mb-2">
          ダイエットプラスのレシピは、国が推奨している基準を参考に考案しております。
        </p>

        <p class="mb-2">
          現在、疾患をお持ちの方や、医師からの指導を受けている方、アレルギーをお持ちの方、乳児やお子様・妊婦の方は、材料と栄養素情報をご確認の上ご利用ください。<br />
        </p>

        <NuxtLink
          to="/s/notice_of_recipe"
          target="_blank"
          rel="noopener"
          class="underline"
        >
          サイトに関する注意事項
          <OpenInNewIcon
            class="inline-block relative -bottom-[4px]"
            :size="16"
          />
        </NuxtLink>
      </div>
    </div>
  </div>
</template>
